import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ef0e3cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Hierarchy")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Loading hierarchy data")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Error loading hierarchy data")

import { watch } from "vue";
import { useRoute } from "vue-router";
import { Node } from "@/api/node-lookup";
import { getHierarchy } from "@/api/node-hierarchy";
import AppDetails from "@/components/AppDetails.vue";
import AppDetail from "@/components/AppDetail.vue";
import AppNodeBadge from "@/components/AppNodeBadge.vue";
import { useQuery } from "@/util/composables";

/** route info */
interface Props {
  /** current node */
  node: Node;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SectionHierarchy',
  props: {
    node: null
  },
  setup(__props: any) {

const props = __props as {
  /** current node */
  node: Node;
}

const route = useRoute();



/** get node hierarchy data */
const {
  query: getData,
  data: hierarchy,
  isLoading,
  isError,
} = useQuery(
  async function () {
    return await getHierarchy(props.node.id, props.node.category);
  },

  /** default value */
  { superClasses: [], equivalentClasses: [], subClasses: [] }
);

/** when path (not hash or query) changed, get new node data */
watch(
  [() => route.path, () => props.node.id, () => props.node.category],
  getData,
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_AppHeading = _resolveComponent("AppHeading")!
  const _component_AppStatus = _resolveComponent("AppStatus")!
  const _component_AppFlex = _resolveComponent("AppFlex")!
  const _component_AppSection = _resolveComponent("AppSection")!

  return (_openBlock(), _createBlock(_component_AppSection, null, {
    default: _withCtx(() => [
      _createVNode(_component_AppHeading, { icon: "sitemap" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      (_unref(isLoading))
        ? (_openBlock(), _createBlock(_component_AppStatus, {
            key: 0,
            code: "loading"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }))
        : (_unref(isError))
          ? (_openBlock(), _createBlock(_component_AppStatus, {
              key: 1,
              code: "error"
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(AppDetails, { key: 2 }, {
              default: _withCtx(() => [
                _createVNode(AppDetail, {
                  title: "Super-classes",
                  icon: "angle-up",
                  blank: !_unref(hierarchy).superClasses.length,
                  big: true,
                  "v-tooltip": `Nodes that are "parents" of this node`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AppFlex, {
                      class: "flex",
                      "h-align": "left",
                      gap: "small"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(hierarchy).superClasses, (_class, index) => {
                          return (_openBlock(), _createBlock(AppNodeBadge, {
                            key: index,
                            node: _class,
                            breadcrumb: { node: __props.node, relation: _class.relation }
                          }, null, 8, ["node", "breadcrumb"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["blank"]),
                _createVNode(AppDetail, {
                  title: "Equivalent classes",
                  icon: "equals",
                  blank: !_unref(hierarchy).equivalentClasses.length,
                  big: true,
                  "v-tooltip": `Nodes that are "siblings" of this node`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AppFlex, {
                      class: "flex",
                      "h-align": "left",
                      gap: "small"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(hierarchy).equivalentClasses, (_class, index) => {
                          return (_openBlock(), _createBlock(AppNodeBadge, {
                            key: index,
                            node: _class,
                            breadcrumb: { node: __props.node, relation: _class.relation }
                          }, null, 8, ["node", "breadcrumb"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["blank"]),
                _createVNode(AppDetail, {
                  title: "Sub-classes",
                  icon: "angle-down",
                  blank: !_unref(hierarchy).subClasses.length,
                  big: true,
                  "v-tooltip": `Nodes that are "children" of this node`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AppFlex, {
                      class: "flex",
                      "h-align": "left",
                      gap: "small"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(hierarchy).subClasses, (_class, index) => {
                          return (_openBlock(), _createBlock(AppNodeBadge, {
                            key: index,
                            node: _class,
                            breadcrumb: { node: __props.node, relation: _class.relation }
                          }, null, 8, ["node", "breadcrumb"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["blank"])
              ]),
              _: 1
            }))
    ]),
    _: 1
  }))
}
}

})